<template>
  <div class="content-wrapper" style="min-height: 481px;">
    <section class="content-header">
      <h1>
        {{ $t('trainings.title') }}
        <small>{{ $t('trainings.subtitle') }}</small>
      </h1>
      <ol class="breadcrumb">
        <li><i class="fa fa-dashboard"></i> <a href="./">Dashboard</a></li>
        <li class="active">{{ $t('trainings.title') }}</li>
      </ol>
    </section>

    <section class="content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="nav-tabs-custom">
            <ul class="nav nav-tabs">
              <li
                v-for="camp in camps"
                :key="camp.id"
                v-bind:class="{ active: camp.id === camps[0].id }">
                <a :href="'#tab_' + camp.id" v-on:click="selectCamp(camp)" data-toggle="tab" aria-expanded="true">
                  {{camp.name[$root.$i18n.locale]}}
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div
                v-for="camp in camps"
                :key="camp.id"
                v-bind:class="getTabClass(camp)"
                :id="'tab_' + camp.id">
                <ProgramContentComponent v-bind:camp="camp"></ProgramContentComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <AddTrainingModalComponent
      v-bind:sport-types="sportTypes"
      v-bind:current-camp="currentCamp"
      v-bind:countries="countries">
    </AddTrainingModalComponent>
  </div>
</template>

<script>
import ProgramContentComponent from './ProgramContent';
// import TrainingDescriptionModalComponent from './TrainingDescriptionModal';
// import TrainingSourceDescriptionComponent from './TrainingSourceDescription';
// import TrainingArrivalsComponent from './TrainingArrivals';
// import TrainingResidencesComponent from './TrainingResidences';
// import TrainingTransfersComponent from './TrainingTransfers';
// import TrainingAdditionalServicesComponent from './TrainingAdditionalServices';
// import TrainingPhotosComponent from './TrainingPhotos';
// import TrainingVideosComponent from './TrainingVideos';
// import TrainingFaqsComponent from './TrainingFaqs';
import AddTrainingModalComponent from './AddTrainingModal';
import axios from 'axios';

export default {
  name: 'CampsContent',
  props: {
    camps: Array,
    countries: Array
  },
  components: {
    ProgramContentComponent,
    // TrainingDescriptionModalComponent,
    // TrainingSourceDescriptionComponent,
    // TrainingArrivalsComponent,
    // TrainingResidencesComponent,
    // TrainingTransfersComponent,
    // TrainingAdditionalServicesComponent,
    // TrainingPhotosComponent,
    // TrainingVideosComponent,
    // TrainingFaqsComponent,
    AddTrainingModalComponent
  },
  created () {
    let self = this;

    axios.get(
      window.host + '/sportTypes')
      .then(function (response) {
        console.log(response.data);
        self.sportTypes = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    self.$root.$on('selectCurrentTraining', function (training) {
      console.log('selectCurrentTraining');
      console.log(training);
      self.currentTraining = training;
    });

    self.$root.$on('selectCurrentCamp', function (camp) {
      console.log(camp);
      self.currentCamp = camp;
    });
  },
  updated () {
    // eslint-disable-next-line no-undef
    $('.box').boxWidget();
  },
  data () {
    return {
      currentCamp: {
        name: {
          en: '',
          ru: ''
        },
        address: {
          en: '',
          ru: ''
        },
        countryId: ''
      },
      sportTypes: [],
      currentTraining: null,
      curCamp: null
    };
  },
  methods: {
    getTabClass: function (camp) {
      return {
        'tab-pane': camp.id !== this.camps[0].id,
        'tab-pane active': camp.id === this.camps[0].id
      };
    },
    showCountry: function (id) {
      var self = this;

      if (self.countries) {
        for (var i = 0; i < self.countries.length; i++) {
          if (self.countries[i].id === id) { return self.countries[i].name; }
        }
      }
      return {'ru': '', 'en': ''};
    },
    selectCamp: function (camp) {
      this.currentCamp = camp;
      console.log(camp.id);
    }
  }
};
</script>

<style scoped>

</style>
